// extracted by mini-css-extract-plugin
module.exports = {"container":"flag_icon_container__uAtI9"};